/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor','顾问甲'];
  return valid_map.indexOf(str.trim()) >= 0;
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

// 手机号码
export function isMobile(rule, value, callback){
  if (!value) {
    return callback();
  }
  setTimeout(() => {
    const re = /^1\d{10}$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('请输入正确的手机号码'));
    } else {
      callback();
    }
  }, 0);
}

// 验证是否数字数
export function isNumberNotMust(rule, value, callback) {
  if (!value) {
    return callback();
  }
  setTimeout(() => {
    if (isNaN(value)) {
      callback(new Error('请输入整数'));
    } else {
      callback();
    }
  }, 0);
}

// 验证身高体重（不超过三位正整数，最多一位小数）
export function isOneNumberDecimal(rule, value, callback) {
  if (!value) {
    return callback();
  }
  setTimeout(() => {
    const re = /^[0-9]{1,3}([.]\d{1})?$/;
    const rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('请输入不超过三位正整数或一位小数'));
    } else {
      callback();
    }
  }, 0);
}

// 验证是否整数
export function isInteger(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(() => {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 0);
}
// 验证是否整数,非必填
export function isIntegerNotMust(rule, value, callback) {
  if (!value) {
    callback();
  }
  setTimeout(() => {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 10);
}